import { useEffect } from "react";

const SettingsFeedback = ({ open, title, message, onClose }) => {
  useEffect(() => {
    if (!open) return undefined;

    const onKeyDown = (event) => {
      if (event.key === "Escape") onClose?.();
    };

    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="settings-feedback" role="presentation">
      <button
        type="button"
        className="settings-feedback__backdrop"
        aria-label="Close"
        onClick={onClose}
      />
      <div
        className="settings-feedback__panel"
        role="dialog"
        aria-modal="true"
        aria-labelledby="settings-feedback-title"
      >
        <div className="settings-feedback__icon" aria-hidden="true">
          <i className="bi bi-check-lg" />
        </div>
        <p className="settings-feedback__kicker">Completed</p>
        <h3 id="settings-feedback-title">{title}</h3>
        <p className="settings-feedback__message">{message}</p>
        <button type="button" className="settings-feedback__btn" onClick={onClose} autoFocus>
          Done
        </button>
      </div>
    </div>
  );
};

export default SettingsFeedback;
